import { BlogsData } from "../services/Cart";
import { withImageVersion } from "../contextApi/ImageVersionContext";

const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();

export const fetchBlogs = async () => {
  try {
    const response = await BlogsData();
    const activeBlogs = response.data.filter(
      (item) => item.active !== false
    );
    return activeBlogs.map((item) => ({
      id: item.sno,
      title: item.blogtitle,
      slug: slugify(item.blogtitle),
      excerpt: item.shortdesc,
      details: [item.fulldesc],
      image: withImageVersion(item.imgurl),
      date: item.created_date,
      author: item.created_by,
      active: item.active,
    }));
  } catch (error) {
    console.log("error fetching blogs:", error);
    throw error;
  }
};
